module.exports = __webpack_public_path__ + "img/title.c5eeeae0.png";